import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "addon"]
    static values = { url: String, revertTitle: { type: String, default: "Cliquez ici pour annuler votre modification" } }
    static classes = ["submit", "revert", "updating"]

    connect() {
        this.initialText = this.inputTarget.value;

        this.inputTarget.addEventListener("focusout", (event) => this.save())
    }

    showRevert() {
        this.addonTarget.classList.add(...this.revertClasses)
        this.addonTarget.title = this.revertTitleValue
    }
    hideRevert() {
        this.addonTarget.classList.remove(...this.revertClasses)
        this.addonTarget.title = ''
    }

    showSpinner() {
        this.addonTarget.classList.add(...this.updatingClasses)
    }

    hideSpinner() {
        this.addonTarget.classList.remove(...this.updatingClasses)
    }

    revert() {
        this.inputTarget.value = this.initialText
        this.post(this.initialText).then((response) => this.hideRevert());
    }

    post(value) {
        const formData = new FormData();
        formData.append(this.inputTarget.name, value)

        return fetch(this.urlValue, { method: "PUT", body: formData, headers: this.headers })
    }

    save() {
        if (this.initialText != this.inputTarget.value) {
            this.showSpinner()

            this.post(this.inputTarget.value).then((response) => { this.hideSpinner(); this.showRevert(); });
        }
    }

    get headers() { return { "X-CSRF-Token": this.getMetaValue("csrf-token"), 'X-Requested-With': 'XMLHttpRequest' } }

    getMetaValue(name) {
        const element = this.findElement(document.head, `meta[name="${name}"]`);
        if (element) {
            return element.getAttribute("content");
        }
    }

    findElement(root, selector) {
        if (typeof root == "string") {
            selector = root;
            root = document;
        }
        return root.querySelector(selector);
    }

}
